import React, { useState } from "react";
import Alert from "./Alert";
import "../Css/Signup.css";
import { useNavigate, Link } from "react-router-dom"; // useHistory is now changed to useNavigatr
import Loader from "./Loader";

export default function Login() {
  const [pass, setpass] = useState("password");
  const [texts, settext] = useState("");
  const [show, setshow] = useState(true);
  const [alert, setalert] = useState({ msg: null, type: "" });
  const [load, setload] = useState(false);
  const [note, setnote] = useState({ Email: "", Password: "" });
  let history = useNavigate();

  const showpass = () => {
    if (pass === "password") {
      setpass("text");
      settext("-slash");
    } else {
      setpass("password");
      settext("");
    }
  };
  const changing = (e) => {
    setload(false)
    const val = e.target.value;
    setnote({ ...note, [e.target.name]: e.target.value });
    if (val.length > 0) {
      setshow(false);
    } else {
      setshow(true);
    }
  };
  const handleClick = async (e) => {
    try {
      e.preventDefault();
      setload(true);
      const response = await fetch(
        `https://inquisitive-shift-fox.cyclic.cloud/api/auth/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ Email: note.Email, Password: note.Password }),
        }
      );
      const data = await response.json();
      console.log(data);
      if (data.success) {
        
        localStorage.setItem("Token", data.authtoken);
        setload(false);
        
        history("/home");
        document.location.reload();
      } else {
        setalert({ msg: "Please Enter Correct Login Details" , type: "danger" });
        setload(false)
        setTimeout(() => {
          setalert({ msg: null, type: "" });
        }, 3000);
      }
    } catch (error) {
      setalert({ msg: "data.mag", type: "danger" });
    }
  };
  return (
    <>
      <div className="w-50 container">
        <div className=""></div>

        <h1 className="text-danger">LogIn</h1>
        <form
          onSubmit={handleClick}
          className="bg-light shadow  px-5 py-5 rounded-3 my-4"
        >
          <div className="mb-3 text-start">
            <label htmlFor="Email" className="form-label text-dark">
              Email address
            </label>
            <input
              type="email"
              autoComplete="on"
              className="form-control"
              id="exampleInputEmail1"
              onChange={changing}
              name="Email"
              aria-describedby="emailHelp"
              required
            />
            <div id="emailHelp" className="form-text text-dark">
              We'll never share your email with anyone else.
            </div>
          </div>
          <div className="mb-3 text-start">
            <label htmlFor="Password" className="form-label text-dark">
              Password
            </label>
            <div className="d-flex fl-r">
              <input
                type={pass}
                autoComplete="on"
                className="form-control"
                name="Password"
                id="exampleInputPassword1"
                onChange={changing}
                required
              />

              <div
                className="mb-3 bg-theme form-check  flex justify-center w-25 items-center  p-0 cursor-pointer round-right"
                onClick={showpass}
              >
               
                <i
                  class={`fa-solid fa-eye${texts} text-white semibold text-theme`}
                  aria-disabled={show}
                ></i>
              </div>
            </div>
          </div>
          <Alert msg={alert.msg} type={alert.type} />
          <Link to="/Reset_password" className="fs-6">
            Forgotten Password
          </Link>
          <div className="d-flex items-center conatiner my-4 fl-c">
            {load ? (
              <div className="mx-3">
                <Loader /> 
                <span className="text-theme my-2">Please Wait..</span>
              </div>
            ) : (
              <button type="submit" className="btn bg-theme text-theme mx-3">
                Login
              </button>
            )}

            <Link to="/signup" className="fs-6 mxt-2">
              Don't have Account ? Create New Account
            </Link>
          </div>
        </form>
        
      </div>
      
    </>
  );
}
